import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IIcon {
    icone?: string,
    uuid?: string,
    nome?: string,
}


const create = async (data: IIcon): Promise<IIcon[]> => {
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('/icone', data, {
            headers: {
                Authorization: `${token}`
            }
        });

        return response.data;
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Erro ao criar ícone');
    }
};

const get = async (): Promise<IIcon[] | Error> => {
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get('/icone', {
            headers: {
                Authorization: `${token}`
            }
        });

        return response.data;
    } catch (error: any) {
        throw new Error(error.response?.data?.message || 'Erro ao buscar ícone');
    }
};

export const IconServices = {
    create,
    get
};